// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyChart_wrapper__IE2ss","title":"EmptyChart_title__sieuB","description":"EmptyChart_description__f9-7P","pageWrapper":"EmptyChart_pageWrapper__-s8-Y"};